import { DebugMode } from '../constants';
import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class TesterDeviceSearchParam extends CommonSearchParam {

  constructor(isDebugMode?: boolean, adid?: string, name?: string) {
    super();
    this.name = name;
    this.adid = adid;
    if (isDebugMode) {
      this.debugMode = DebugMode.ON;
    }
  }

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'adid' })
  adid: string;

  @ApiBind({ column: 'debug_mode' })
  debugMode: number;
}
